import React from 'react';
import SmallContainer from '../containers/small/small-container';
import LoginActions from '../login-actions/login-actions';

const LoginPage = ({ children }) => {
  const renderLoginActions = () => {
    const currentPath = window.location.pathname;

    switch (currentPath) {
      case '/login':
        return (
          <LoginActions
            redirectLinks={[
              {
                text: 'Forgot your password?',
                route: '/reset-password',
              },
            ]}
            buttonText="LOG IN"
          />
        );
      case '/new-password':
        return (
          <LoginActions
            redirectLinks={[
              {
                text: 'Log in with another account',
                route: '/login',
              },
            ]}
            buttonText="SET NEW PASSWORD"
          />
        );
      case '/reset-password':
        return (
          <LoginActions
            redirectLinks={[
              {
                text: 'I already have a code',
                route: '/reset-password/confirm',
              },
              {
                text: 'Back to login',
                route: '/login',
              },
            ]}
            buttonText="GET CONFIRMATION CODE"
          />
        );
      case '/reset-password/confirm':
        return (
          <LoginActions
            redirectLinks={[
              {
                text: 'Back to login',
                route: '/login',
              },
            ]}
            buttonText="RESET PASSWORD"
          />
        );
      default:
        return null;
    }
  };

  return (
    <SmallContainer>
      {React.Children.map(children, (child) => React.cloneElement(child))}
      {renderLoginActions()}
    </SmallContainer>
  );
};

export default LoginPage;
